import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import ShareBetslipImpl from './share-betslip.js';

/**
 * A module that displays a share betslip dialog.
 * Clicking the button opens a dialog with sharing options.
 *
 * @class ShareBetslip
 * @memberof Mojito.Modules
 */

/**
 * ShareBetslip prop types.
 *
 * @property {string} betslipId - The unique identifier for the betslip.
 * @property {Array<string>} betRefs - Array of bet references.
 * @property {React.Node} children - Component children.
 * @property {string} [class] - Class name assigned to the root element.
 *
 * @memberof Mojito.Modules.ShareBetslip
 */
const propTypes = {
    betslipId: PropTypes.string.isRequired,
    betRefs: PropTypes.arrayOf(PropTypes.string),
    children: PropTypes.node,
    class: PropTypes.string,
};

export default MojitoCore.Presentation.UIView('ShareBetslip', ShareBetslipImpl, propTypes);
